export default __webpack_public_path__ + "static/media/Error.66dad618.png";